module.exports = __webpack_public_path__ + "media/app/images/logo@2x-42df94a4b1d62166de242a68f3194f53.png";